import {Component, inject, input, output, viewChild, ViewEncapsulation} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DxDataGridComponent, DxDataGridModule} from 'devextreme-angular';
import {CellPreparedEvent} from 'devextreme/ui/data_grid';
import {SharedModule} from '../../shared.module';
import {ButtonThemeEnum} from '../../ui/button/button-theme-enum';
import {IconThemeEnum} from '../../ui/icon/icon-theme-enum';
import {PlcProduitComplementaireDTO} from '../../../core/dtos/plc-produit-complementaire-dto';
import {JourToggle} from '../../../core/models/gestion-produits/declinaison/complementaire/plc/jour-toggle';
import {PRODUIT_COMPLEMENTAIRE_PAGE_SIZE} from '../../../core/services/entities/plc-produit-complementaire.service';
import {
  ProduitComplementaireParametrageService
} from '../../../core/services/entities/produit-complementaire-parametrage.service';

@Component({
  selector: 'yo-produit-complementaire-grid',
  templateUrl: './produit-complementaire-grid.component.html',
  styleUrls: ['./produit-complementaire-grid.component.scss'],
  standalone: true,
  imports: [DxDataGridModule, SharedModule, DatePipe],
  encapsulation: ViewEncapsulation.None
})
export class ProduitComplementaireGridComponent {

  readonly PAGE_SIZE = PRODUIT_COMPLEMENTAIRE_PAGE_SIZE;
  readonly ButtonThemeEnum = ButtonThemeEnum;
  readonly IconThemeEnum = IconThemeEnum;

  readonly produitComplementaireList = input.required<PlcProduitComplementaireDTO[]>();

  readonly editable = input<boolean>(true);

  readonly noDataText = input<string>('');

  /**
   * Clé de ligne DevExtreme. Une ligne vaut un produit décliné quand le point de livraison est fixé par l'écran
   * hôte, le couple (point de livraison, produit décliné) quand la grille en affiche plusieurs.
   */
  readonly keyExpr = input<string | string[]>('produitDeclinaisonId');

  /** Colonne « Point de livraison » : utile au paramétrage vu de la fiche produit, hors sujet vu du PLC. */
  readonly plcColonneVisible = input<boolean>(false);

  /** Pagination interne DevExtreme : à désactiver quand la pagination est pilotée en dehors de la grille. */
  readonly pagingInterne = input<boolean>(false);

  readonly suppressionIconClass = input<string>('fas fa-trash');

  readonly suppressionTooltip = input<string>('Supprimer');

  readonly periodeClick = output<PlcProduitComplementaireDTO>();

  readonly suppressionClick = output<PlcProduitComplementaireDTO>();

  readonly jourClick = output<JourToggle>();

  /** DevExtreme modifie la ligne en place : l'hôte doit être prévenu pour réévaluer ses modifications en attente. */
  readonly ligneEditee = output<void>();

  readonly paramSvc = inject(ProduitComplementaireParametrageService);

  private readonly grid = viewChild(DxDataGridComponent);

  onCellPrepared = (event: CellPreparedEvent): void => this.paramSvc.applyCelluleClassList(event, this.editable());

  onCellClick = (cell: CellPreparedEvent): void => {
    const jour = this.paramSvc.findJourCellule(cell);
    if (!jour || !this.editable()) {
      return;
    }
    this.jourClick.emit({produitDeclinaisonId: cell.data.produitDeclinaisonId, jourId: jour.id, plcId: cell.data.plcId});
  };

  clearFiltreColonne = (): void => this.grid()?.instance.clearFilter('header');

  saveEditData = (): Promise<void> => this.grid()?.instance.saveEditData() ?? Promise.resolve();
}
